/**
 * Memo Management Types
 *
 * Type definitions for diamond memo requests and tracking
 */
export var MemoStatus;
(function (MemoStatus) {
    MemoStatus["PENDING"] = "pending";
    MemoStatus["APPROVED"] = "approved";
    MemoStatus["SHIPPED"] = "shipped";
    MemoStatus["WITH_CLIENT"] = "with_client";
    MemoStatus["RETURNED"] = "returned";
    MemoStatus["SOLD"] = "sold";
    MemoStatus["CANCELLED"] = "cancelled";
    MemoStatus["REJECTED"] = "rejected"; // Request denied
})(MemoStatus || (MemoStatus = {}));
export const MEMO_STATUS_LABELS = {
    [MemoStatus.PENDING]: 'Pending Approval',
    [MemoStatus.APPROVED]: 'Approved',
    [MemoStatus.SHIPPED]: 'Shipped',
    [MemoStatus.WITH_CLIENT]: 'With Client',
    [MemoStatus.RETURNED]: 'Returned',
    [MemoStatus.SOLD]: 'Sold',
    [MemoStatus.CANCELLED]: 'Cancelled',
    [MemoStatus.REJECTED]: 'Rejected'
};
export const MEMO_STATUS_COLORS = {
    [MemoStatus.PENDING]: '#f59e0b',
    [MemoStatus.APPROVED]: '#3b82f6',
    [MemoStatus.SHIPPED]: '#8b5cf6',
    [MemoStatus.WITH_CLIENT]: '#06b6d4',
    [MemoStatus.RETURNED]: '#22c55e',
    [MemoStatus.SOLD]: '#10b981',
    [MemoStatus.CANCELLED]: '#6b7280',
    [MemoStatus.REJECTED]: '#ef4444'
};
